export default "__VITE_PUBLIC_ASSET__baf42e07__"